import React from 'react'
import TwoColumns from 'elements/ClientTwoColumns'
import Cell from 'elements/Cell'
import DateValue from 'elements/DateValue'
import rt from 'components/reactable.scss'
import {Table, Thead, Th, Tr, Td} from 'components/reactable'
import styles from 'elements/client.scss'

import i18n from 'lib/i18n'
const _ = i18n('claimsES')

const ClientClaimDetails = ({claim, onBackClicked, className}) => {
	const col1 = [
		{label: _('insuranceCompany'), value: claim.claimDetails.insuranceCompany},
		{label: _('status'), value: claim.claimMain.state},
		{label: _('contractNumberSh'), value: claim.claimMain.contractNumber},
		{label: _('riskDescription'), value: claim.claimDetails.riskDescription},
	]

	const col2 = [
		{label: _('creationDate'), value: <DateValue date={claim.claimMain.creationDate}/>},
		{label: _('qualification'), value: claim.claimMain.qualification},
		{label: _('branche'), value: claim.claimDetails.branche},
	]

	return (
		<Cell className={className}>
			<div className={styles.claimHeader}>
				<div className={styles.contractTitle}>
					{`${_('claimNumber')} ${claim.claimMain.claimNumber}`}
				</div>
				<div onClick={() => onBackClicked()} className={styles.backButton}>
					<button>← {_('back')}</button>
				</div>
			</div>
			<TwoColumns col1={col1} col2={col2}/>
			<div className={styles.sectionHeader}>
				{_('images')}:
			</div>
			<Table
				className="table"
				itemsPerPage={7}
				filterPlaceholder={_('placeholder')}
				filterable={['documentType', 'documentDate']}
				sortable={[
				{column: 'documentDate', sortFunction: 'Date'},
					'documentType',
				]}
				defaultSort={{
					column: 'documentDate',
					direction: 'desc',
				}}
			>
				<Thead>
					<Th column="documentMetaCol" label=""/>
					<Th column="documentType">
						<strong>{_('type')}</strong>
					</Th>
					<Th column="documentDate">
						<strong>{_('date')}</strong>
					</Th>
				</Thead>
				{claim.claimDocuments.length > 0 &&
					claim.claimDocuments.map((item, i) => (
						<Tr
							i={item.id}
							key={i}
							className="clickable"
							onClick={() => window.open(`/data/document?id=${item.documentId}`, '_blank', 'noopener,noreferrer')}
						>
							<Td column="documentMetaCol" data={item.id} className={rt.pdfIcon}>
								<div><img src={require('resources/images/pdf-icon_1x.png')}/></div>
							</Td>
							<Td column="documentType" data={item.documentType}/>
							<Td column="documentDate" className={rt.date} value={item.documentDate}>
								<DateValue date={item.documentDate}/>
							</Td>
						</Tr>
				))}
			</Table>
		</Cell>
	)
}

export default ClientClaimDetails



// WEBPACK FOOTER //
// ./elements/ClientClaimDetails.jsx